<template>
  <div class="orderdetail">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">订单详情</a></li>
        </ul>
      </nav>
    </div>
    <div class="top-order">
      <div class="left">
          <img src="../../assets/img/listpic.png" alt="">
      </div>
      <div class="right">
          <h2><a>订单编号:{{order.code}}</a><span class="pay">{{order.paystatus === 'y' ? '已支付' : '未支付'}}</span></h2>
          <p class="orderdate"></p>
          <p class="text">购买产品种类 : <span>{{order.catalogs}}</span>  总交付面积 : <span>{{order.area}}</span>  使用代金券金额  :  <span>{{order.voucherAmount}}</span></p>
      </div>
    </div>
    <p class="t-title">
      <el-select v-model="catalogCode" placeholder="请选择">
        <el-option
          v-for="item in orderInfos"
          :key="item.catalog_code"
          :label="item.catalog_name"
          :value="item.catalog_code">
        </el-option>
      </el-select>
      <span>&nbsp;</span>
      购买数量:<span class="red">{{totalCount}}</span>
      交付面积:<span class="red">{{area}}</span>
      单价:<span class="red">{{price}}元/km²</span>
      <span class="fr">
        总价:<span class="red">{{totalPrice}}</span>
      </span>
    </p>
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      class="detail">
      <el-table-column
        label="#"
        width="40"
        align="center"
        >
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column
        label="商品名称"
        width="240"
        align="center">
        <template slot-scope="scope">
          <span class="product-name" :title="scope.row.product_name" v-if="order.orderType===1">{{ scope.row.product_name }}</span>
          <span class="product-name" :title="scope.row.imageFileName" v-else>{{ scope.row.imageFileName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="日期"
        width="180">
        <template slot-scope="scope">
          {{order.orderType===1 ? scope.row.product_date : scope.row.productDate}}
        </template>
      </el-table-column>
      <el-table-column
        prop="region"
        label="隶属行政区"
        align="center"
        >
      </el-table-column>
      <el-table-column
        prop="area"
        label="交付面积"
        align="center"
        >
      </el-table-column>
      <el-table-column
        label="当前状态"
        align="center"
        >
        <template slot-scope="scope">
          {{ order.orderType===1 ? product_status_cn(scope.row.product_status) : scope.row.status }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>5">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="5"
        background
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>

export default {
  name: 'orderdetail',
  components: {
  },
  created () {
    this.order = this.$route.params.order
    this.initOrderInfo()
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      order: {},
      tableData: [],
      catalogCode: '',
      orderInfos: [],
      totalCount: 0,
      area: 0,
      price: 0,
      totalPrice: 0
    }
  },
  methods: {
    handleCurrentChange (value) {
      this.currentPage = value
      this.initOrderInfo()
    },
    initOrderInfo() {
      let queryParam = {
        currentPage: this.currentPage,
        orderId: this.order.id,
        orderType: this.order.orderType,
        catalogCode: this.catalogCode
      }
      this.sapost('/dmc/order/orderInfoByCatalog', queryParam, r => {
        let {orderInfos, pager, currentCode} = r.data
        this.catalogCode = currentCode
        this.tableData = pager.list
        this.orderInfos = orderInfos
        this.total = pager.total
      })
    },
    product_status_cn(value) {
      if (value === '0') {
        return '未生产'
      }
      if (value === '1') {
        return '生产中'
      }
      if (value === '2') {
        return '生产完成'
      }
    }
  },
  watch: {
    catalogCode(value) {
      this.currentPage = 1
      let item = this.orderInfos.find(order => order.catalog_code === value)
      this.totalCount = item.productCount
      this.area = item.totalArea
      this.totalPrice = item.totalPrice
      if (this.area === undefined) {
        this.price = 0
      } else {
        this.price = (this.totalPrice / this.area).toFixed(4)
      }
      this.initOrderInfo()
    }
  }
}
</script>

<style lang="less">
.orderdetail{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
      }
    }
  }
  .top-order{
    padding: 25px 0px;
    border-bottom: 1px solid #ddd;
    overflow: hidden;
    .left{
        float: left;
    }
    .right{
        margin-left: 230px;
        h2{
            font-size: 18px;
            .pay{
                font-size: 12px;
                color: red;
                margin-left: 45px;
            }
            .comment{
                font-size: 14px;
                float: right;
                margin-right: 15px;
            }
        }
        .orderdate{
            padding: 15px 0px;
            color: #999;
            span{
                margin-right: 40px;
            }
        }
        .text {
            padding-top: 10px;
            color: #666;
            span{
                color: #f01400;
                margin-right: 15px;
            }
            .look{
                padding: 5px;
                float: right;
                border: 1px solid #f01400;
                margin-right: 10px;
                a{
                    color: #f01400;
                }
            }
        }
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .t-title{
    margin: 15px 0px 15px;
    background-color: #eeeeee;
    span.red{
      color: #f71c16;
      margin-right: 15px;
    }
    span.price{
      color: #f71c16;
    }
    span.fr{
      float: right;
      vertical-align: middle;
      height: 40px;
      line-height: 40px;
    }
  }
  .detail {
    thead {
      color: #333;
    }
    .product-name{
      display: inline-block;
      width: 200px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      vertical-align: bottom;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderdetail.vue